import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=0b56ba70&scoped=true"
import script from "./Limit.vue?vue&type=script&lang=js"
export * from "./Limit.vue?vue&type=script&lang=js"
import style0 from "./Limit.vue?vue&type=style&index=0&id=0b56ba70&prod&lang=scss&scoped=true"
import style1 from "./Limit.vue?vue&type=style&index=1&id=0b56ba70&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b56ba70",
  null
  
)

export default component.exports